
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["businessCenter_svg__icon",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 1024 1024","xmlns":"http://www.w3.org/2000/svg","width":"128","height":"128"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M642.91 395.636h-256a34.91 34.91 0 100 69.819h256a34.91 34.91 0 100-69.819zM270.544 256a34.91 34.91 0 100-69.818h-58.181a46.545 46.545 0 00-46.546 46.545V418.91a46.545 46.545 0 0046.546 46.546h58.181a34.91 34.91 0 100-69.819h-34.909V256h34.91zM642.91 768h-256a34.91 34.91 0 100 69.818h256a34.91 34.91 0 100-69.818zm0-581.818h-256a34.91 34.91 0 100 69.818h256a34.91 34.91 0 100-69.818zM270.545 628.364a34.91 34.91 0 100-69.819h-58.181a46.545 46.545 0 00-46.546 46.546v186.182a46.545 46.545 0 0046.546 46.545h58.181a34.91 34.91 0 100-69.818h-34.909V628.364h34.91zm672 69.818a34.91 34.91 0 0034.91-34.91V139.637a93.09 93.09 0 00-93.091-93.09H139.636a93.09 93.09 0 00-93.09 93.09v744.728a93.09 93.09 0 0093.09 93.09h744.728a93.09 93.09 0 0093.09-93.09v-81.455a34.91 34.91 0 10-69.818 0v81.455a23.273 23.273 0 01-23.272 23.272H139.636a23.273 23.273 0 01-23.272-23.272V139.636a23.273 23.273 0 0123.272-23.272h744.728a23.273 23.273 0 0123.272 23.272v523.637a34.91 34.91 0 0034.91 34.909zM864 232.727a46.545 46.545 0 00-46.545-46.545h-58.182a34.91 34.91 0 100 69.818h34.909v139.636h-34.91a34.91 34.91 0 100 69.819h58.183A46.545 46.545 0 00864 418.909V232.727zM642.91 558.545h-256a34.91 34.91 0 100 69.819h256a34.91 34.91 0 100-69.819zM759.272 768a34.91 34.91 0 100 69.818h58.182A46.545 46.545 0 00864 791.273V605.09a46.545 46.545 0 00-46.545-46.546h-58.182a34.91 34.91 0 100 69.819h34.909V768h-34.91z"}})])
          )
        }
      }
    